var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServicesIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.104.818A2.286 2.286 0 0 0 .818 3.104V8.35a2.286 2.286 0 0 0 2.286 2.285h5.247a2.286 2.286 0 0 0 2.285-2.285V3.104A2.286 2.286 0 0 0 8.351.818H3.104zm0 10.546a2.286 2.286 0 0 0-2.286 2.285v5.247a2.286 2.286 0 0 0 2.286 2.286h5.247a2.286 2.286 0 0 0 2.285-2.286V13.65a2.286 2.286 0 0 0-2.285-2.285H3.104zm8.26 2.285a2.286 2.286 0 0 1 2.285-2.285h5.247a2.286 2.286 0 0 1 2.286 2.285v5.247a2.286 2.286 0 0 1-2.286 2.286H13.65a2.286 2.286 0 0 1-2.285-2.286V13.65zM13.649.82a2.286 2.286 0 0 0-2.285 2.285V8.35a2.286 2.286 0 0 0 2.285 2.285h5.247a2.286 2.286 0 0 0 2.286-2.285V3.104A2.286 2.286 0 0 0 18.896.818H13.65z",
    fill: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesIcon);
export default __webpack_public_path__ + "static/media/servicesIcon.956f508813aa2eb41e5a427c1d6412bd.svg";
export { ForwardRef as ReactComponent };